import React from 'react';
import PropTypes from 'prop-types';
import { appConfig } from '../../config';

class ImageMosaicDto {
  constructor(json) {
    this.id = json.id;
    this.label = json.label;
    this.description = json.description;
    this.extraInformation = json.extraInformation;
    this.imageUrl = json.imageUrl;
    this.selected = json.selected;
    this.padding = json.padding;
    this.disabled = json.disabled;
  }
}

const ImageMosaic = ({ data, onClick, mdWidthColumns, customClassName }) => {
  const {
    id,
    label,
    description,
    extraInformation,
    imageUrl,
    selected,
    disabled,
    padding,
  } = data;
  const paddingStyle = padding ? padding : 'p-1';
  const selectedStyle = selected ? 'selected' : '';
  const disabledStyle = disabled ? 'disabled' : '';
  const cursorStyle = disabled ? '' : 'cursor-pointer';
  return (
    <div
      className={`image-mosaic col-md-${mdWidthColumns} col-4 ${paddingStyle} ${cursorStyle} ${selectedStyle} ${disabledStyle} ${customClassName}`}
      onClick={(e) => (disabled ? {} : onClick(id))}
    >
      {imageUrl && (
        <div className="img-container d-flex justify-content-center">
          {appConfig.showDebugInfo && <div>{id}</div>}
          <img
            src={imageUrl}
            className="img-fluid mx-auto d-block"
            alt={label}
            draggable="false"
          />
        </div>
      )}
      <div className="mosaic-label">{label}</div>
      {description && <div className="mosaic-description">{description}</div>}
      {extraInformation && (
        <div
          className={`mosaic-extra-information ${description ? '' : 'mt-auto'}`}
        >
          {extraInformation}
        </div>
      )}{' '}
      {/* We only want to add the mt-auto class if there is NO description */}
    </div>
  );
};

ImageMosaic.propTypes = {
  data: PropTypes.instanceOf(ImageMosaicDto),
  onClick: PropTypes.func.isRequired,
  mdWidthColumns: PropTypes.number,
  customClassName: PropTypes.string,
};

ImageMosaic.defaultProps = {
  mdWidthColumns: 2,
  customClassName: '',
};

export { ImageMosaic, ImageMosaicDto };
